export const waitForElementById = (selector: string) => {
  return new Promise((resolve) => {
    if (document.getElementById(selector)) {
      // eslint-disable-next-line no-promise-executor-return
      return resolve(document.getElementById(selector));
    }

    const observer = new MutationObserver((_mutations) => {
      if (document.getElementById(selector)) {
        resolve(document.getElementById(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};
